// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseInterval } from '@shared/utils/History/BaseInterval';
import { BaseIntervalInputParams } from '@shared/utils/History/BaseIntervalInputParams';
import { Periods } from '@shared/utils/History/TFInfo';
export class HistoryMerger {
    constructor(inputParams) {
        var _a;
        this.baseHistory = inputParams.BaseHistory;
        this.newPeriod = inputParams.NewPeriod;
        this.instrument = inputParams.Instrument;
        this.session = (_a = this.instrument) === null || _a === void 0 ? void 0 : _a.Session;
    }
    MergeHistory() {
        const newHistory = [];
        const isBasedByDayBars = this.newPeriod % Periods.DAY === 0 || this.newPeriod % Periods.YEAR === 0;
        for (let i = 0; i < this.baseHistory.length;) {
            const baseBar = this.baseHistory[i];
            // hsa: суть проблемы в том что если бары агрегируются по дневкам
            // то надо брать середину бара как базовую точку
            // потому что исторические бары могут не совпадать с настройками сессии
            // и мы берем середину бара чтобы понимать в какой день сессии попала большая часть бара
            const baseFromUtc = isBasedByDayBars ? this.GetBarMiddleTimeUtc(baseBar) : baseBar.LeftTime;
            // возвращает границы агрегированного бара по времени базового бара
            const interval = this.FindIntervalBorders(baseFromUtc);
            const aggFromUtc = interval.From;
            const aggToUtc = interval.To;
            // кейс когда бар есть а сессии в этот день для него нет
            // например в выходные или в праздник
            // в теории такого быть не должно, на QA иногда заливает историю как попало
            if (aggFromUtc.getTime() === 0 || aggToUtc.getTime() === 0) {
                i++;
                continue;
            }
            const biInputParams = new BaseIntervalInputParams();
            biInputParams.LeftTimeTicks = aggFromUtc.getTime();
            biInputParams.correctStartTime = false;
            const aggregatedBar = new BaseInterval(biInputParams, this.newPeriod);
            aggregatedBar.SessionType = baseBar.SessionType;
            aggregatedBar.FLeftTimeTicks = aggFromUtc.getTime();
            aggregatedBar.FRightTimeTicks = aggToUtc.getTime();
            aggregatedBar.LeftTime = aggFromUtc;
            aggregatedBar.RightTime = aggToUtc;
            while (i < this.baseHistory.length && this.baseHistory[i].LeftTime < aggregatedBar.RightTime) {
                aggregatedBar.MergeWith(this.baseHistory[i++], -100); // hsa: history type нужен только для агрегации тиков
            }
            newHistory.push(aggregatedBar);
        }
        return newHistory;
    }
    GetBarMiddleTimeUtc(bar) {
        const leftBorder = bar.LeftTime;
        const rightBorder = bar.RightTime;
        const midllePoint = (leftBorder.getTime() + rightBorder.getTime()) / 2;
        return new Date(midllePoint);
    }
}
